import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import { ArrowRight, Check } from "lucide-react";

export default function Services() {
  const { t } = useI18n();
  return (
    <div data-testid="page-services" className="bg-ct3f-bg text-white">
      <section className="border-b border-white/10 bg-flame-radial">
        <div className="px-6 md:px-12 lg:px-20 py-20 lg:py-28 relative">
          <div className="absolute inset-0 grid-lines pointer-events-none opacity-50" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-7">
              <span className="label-tech text-ct3f-amber">{t.services.eyebrow}</span>
              <h1 className="font-display font-black uppercase tracking-tighter text-5xl md:text-6xl lg:text-8xl mt-4 leading-[0.95]">
                <span className="text-white">{t.services.title}</span>
                <span className="text-flame">.</span>
              </h1>
            </div>
            <div className="lg:col-span-5">
              <p className="text-white/70 text-lg max-w-md">{t.services.sub}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-white/10">
        <div className="px-6 md:px-12 lg:px-20 py-16 lg:py-20">
          <div className="border-t border-l border-white/10">
            {t.services.list.map((s, i) => (
              <div
                key={s.k}
                data-testid={`services-item-${i}`}
                className="grid grid-cols-1 lg:grid-cols-12 border-r border-b border-white/10 bg-ct3f-surface"
              >
                <div className="lg:col-span-2 p-8 lg:p-10 border-b lg:border-b-0 lg:border-r border-white/10 flex flex-col justify-between min-h-[200px]">
                  <span className="label-tech text-ct3f-amber">{s.k}</span>
                  <span className="font-display text-7xl lg:text-8xl font-black tracking-tighter text-white/[0.06]">
                    0{i + 1}
                  </span>
                </div>
                <div className="lg:col-span-7 p-8 lg:p-10">
                  <h2 className="font-display font-bold text-3xl lg:text-4xl tracking-tight text-white">
                    {s.t}
                  </h2>
                  <p className="mt-4 text-white/65 leading-relaxed text-lg max-w-2xl">{s.d}</p>
                  {s.cta && (
                    <Link
                      to={`/contact?service=${encodeURIComponent(s.t)}`}
                      data-testid="services-coc-quote-button"
                      className="group mt-6 inline-flex items-center gap-3 bg-flame text-white label-tech px-6 py-3.5 hover:brightness-110 ring-flame transition-all"
                    >
                      {s.cta}
                      <ArrowRight size={16} className="hover-arrow" />
                    </Link>
                  )}
                </div>
                <div className="lg:col-span-3 p-8 lg:p-10 border-t lg:border-t-0 lg:border-l border-white/10 bg-ct3f-elevated">
                  <span className="label-tech text-white/40">INCLUS</span>
                  <ul className="mt-4 space-y-3">
                    {s.items.map((it) => (
                      <li key={it} className="flex items-start gap-3">
                        <Check size={16} className="mt-1 text-ct3f-amber shrink-0" />
                        <span className="text-white/90">{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-flame text-white relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-30 mix-blend-overlay"
          style={{
            background:
              "radial-gradient(circle at 10% 90%, rgba(0,0,0,0.4), transparent 55%)",
          }}
        />
        <div className="relative px-6 md:px-12 lg:px-20 py-20 lg:py-24 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
          <div>
            <span className="label-tech text-white/85">PRÊT POUR LE CONTRÔLE ?</span>
            <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl lg:text-6xl mt-3">
              {t.home.ctaTitle}.
            </h2>
          </div>
          <Link
            to="/contact"
            data-testid="services-cta"
            className="group inline-flex items-center gap-3 bg-ct3f-bg text-white label-tech px-8 py-5 hover:bg-black transition-colors"
          >
            {t.home.ctaButton}
            <ArrowRight size={18} className="hover-arrow" />
          </Link>
        </div>
      </section>
    </div>
  );
}
